import React from 'react';

import Select, { SelectProps } from '@components/Formik/Select';

import { useTranslation } from '@external/react-i18next';

export enum DominoMeetingType {
  Hybrid = 'In Person and Online',
  Online = 'Online',
  Physical = 'In Person',
}

const MeetingTypeSelect: React.FC<Omit<SelectProps, 'options'>> = props => {
  const { t } = useTranslation();
  const options = [
    {
      label: t('global.meetingtype.physical', 'In Person Only'),
      value: DominoMeetingType.Physical,
    },
    {
      label: t('global.meetingtype.online', 'Online Only'),
      value: DominoMeetingType.Online,
    },
    {
      label: t('global.meetingtype.hybrid', 'In Person and Online'),
      value: DominoMeetingType.Hybrid,
    },
  ];
  return <Select {...props} options={options} />;
};

export default MeetingTypeSelect;
